import { Link, useLocation } from "react-router-dom";

export default function PublicNav({ light = false }) {
  const { pathname } = useLocation();
  const links = [
    { to: "/designs", label: "Designs" },
    { to: "/materials", label: "Materials" },
    { to: "/process", label: "Process" },
    { to: "/investment", label: "Investment" },
    { to: "/architects", label: "Architects" },
    { to: "/about", label: "About" },
  ];
  const c = light ? "text-white" : "text-foreground";
  const hover = light ? "hover:text-[color:hsl(var(--accent))]" : "hover:text-[color:hsl(var(--accent))]";
  return (
    <header className={`absolute top-0 inset-x-0 z-20 ${c}`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex justify-between items-center">
        <Link to="/" className="block" data-testid="brand-home"
              aria-label="Subtend Studio">
          <div className="text-[11px] tracking-[0.32em] font-bold"
               style={{ color: "#A68A64", lineHeight: 1.05 }}>SUBTEND</div>
          <div className="text-[11px] tracking-[0.32em] font-bold"
               style={{ color: light ? "#F4EFE4" : "#1C1C1C", lineHeight: 1.05 }}>STUDIO</div>
        </Link>
        <nav className="hidden md:flex items-center gap-7">
          {links.map((l) => (
            <Link key={l.to} to={l.to}
              className={`text-sm tracking-wide transition-colors ${hover} ${pathname === l.to ? "text-[color:hsl(var(--accent))]" : ""}`}
              data-testid={`nav-${l.label.toLowerCase()}`}>
              {l.label}
            </Link>
          ))}
        </nav>
        <Link to="/enquiry" data-testid="nav-enquire" className={`btn-accent`} style={{ padding: "10px 20px" }}>
          Enquire
        </Link>
      </div>
    </header>
  );
}
